import React, { useState, useContext, useEffect } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config'
import { AuthContext } from '../contexts/AuthContext'
import PasswordInput from '../components/common/PasswordInput'
import PasswordRequirements from '../components/common/PasswordRequirements'
import { validatePassword } from '../utils/validatePassword'

export default function AddUser() {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [position, setPosition] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || !user.site_admin) {
      history.push('/');
    }
  }, [user, history]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!validatePassword(password)) {
      setError('Password does not meet the requirements below.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${config.apiUrl}/api/user/register-cms`, {
        data: {
          email,
          position,
          password,
          site_admin: true
        }
      });
      setSuccess('User added successfully!');
      setEmail('');
      setPosition('');
      setPassword('');
      setConfirmPassword('');
      setTimeout(() => {
        setSuccess('');
        setError('');
      }, 2000);
    } catch (err) {
      const serverErrors = err.response?.data?.errors;
      setError(serverErrors?.length ? serverErrors.join(' ') : (err.response?.data?.message || 'Failed to add user.'));
    }
    setLoading(false);
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Add User</h2>
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group id="email" style={{ display: 'flex', flexDirection: 'column' }}>
            <Form.Label>Email</Form.Label>
            <Form.Control className="auth-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </Form.Group>
          <Form.Group id="position" style={{ display: 'flex', flexDirection: 'column' }}>
            <Form.Label>Position</Form.Label>
            <Form.Control className="auth-input" type="text" value={position} onChange={e => setPosition(e.target.value)} required />
          </Form.Group>
          <Form.Group id="password" style={{ display: 'flex', flexDirection: 'column' }}>
            <Form.Label>Password</Form.Label>
            <PasswordInput className="auth-input" value={password} onChange={e => setPassword(e.target.value)} required />
          </Form.Group>
          <PasswordRequirements password={password} />
          <Form.Group id="confirmPassword" style={{ display: 'flex', flexDirection: 'column' }}>
            <Form.Label>Confirm Password</Form.Label>
            <PasswordInput className="auth-input" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
          </Form.Group>
          <Button className="auth-btn auth-btn-primary" type="submit" disabled={loading}>
            Add User
          </Button>
        </Form>
      </div>
    </div>
  );
} 